import { useContext, useMemo } from "react";
import { AuthContext, AuthContextValue } from "./AuthContext";

/**
 * Provides a method for receiving the current authentication refresh token as well as setting the authentication refresh token.
 * @returns A tuple containing the currently logged in session's authentication refresh token or null if not logged in and a function for setting the current authentication refresh token.
 */
export function useAuthRefreshToken(): [string | null, AuthContextValue["setAuthRefreshToken"]] {
  const { authRefreshToken, setAuthRefreshToken } = useContext(AuthContext);

  return useMemo<ReturnType<typeof useAuthRefreshToken>>(() => {
    return [authRefreshToken, setAuthRefreshToken];
  }, [authRefreshToken, setAuthRefreshToken]);
}
